import PropTypes from 'prop-types';
import { Plus } from 'lucide-react';

import { Button } from '#/modules/commonComponents/button';
import TabbedDetailCard from '#/modules/commonComponents/layout/TabbedDetailCard';
import { REPAIR_REQUEST_STATUS } from '#/modules/crmMgmt/aftersales/repairRequest/helper/repairRequestStatus';

import RepairRequestCorrectionHistoryList from './RepairRequestCorrectionHistoryList';
import RepairRequestLinesTable from './RepairRequestLinesTable';

/** 詳情下方分頁：報修明細／更正紀錄（草稿尚無更正，不顯示）。 */
const RepairRequestDetailTabs = ({ detail, correctionActions = null }) => {
  const showCorrections = Boolean(detail?.id) && detail?.status !== REPAIR_REQUEST_STATUS.DRAFT;
  const lineActions = correctionActions?.enabled ? correctionActions : null;

  return (
    <TabbedDetailCard defaultValue="lines">
      <TabbedDetailCard.List>
        <TabbedDetailCard.Trigger value="lines">報修明細</TabbedDetailCard.Trigger>
        {showCorrections ? (
          <TabbedDetailCard.Trigger value="corrections">更正紀錄</TabbedDetailCard.Trigger>
        ) : null}
      </TabbedDetailCard.List>

      <TabbedDetailCard.Pane
        value="lines"
        title="報修明細"
        actions={lineActions ? (
          <Button
            type="button"
            size="sm"
            variant="outline"
            disabled={lineActions.isPending}
            onClick={lineActions.openAddLine}
          >
            <Plus className="size-3.5" aria-hidden />
            新增品項
          </Button>
        ) : null}
      >
        <RepairRequestLinesTable
          lines={detail?.lines ?? []}
          requestStatus={detail?.status}
          repairRequestNo={detail?.repairRequestNo ?? null}
          showLineActions
          lineCorrectionActions={lineActions}
        />
      </TabbedDetailCard.Pane>

      {showCorrections ? (
        <TabbedDetailCard.Pane
          value="corrections"
          title="更正紀錄"
          hint="僅內部可見；客戶查詢只顯示目前資料"
        >
          <RepairRequestCorrectionHistoryList detail={detail} className="p-4" />
        </TabbedDetailCard.Pane>
      ) : null}
    </TabbedDetailCard>
  );
};

RepairRequestDetailTabs.propTypes = {
  detail: PropTypes.shape({
    id: PropTypes.string,
    status: PropTypes.string,
    repairRequestNo: PropTypes.string,
    lines: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  correctionActions: PropTypes.shape({
    enabled: PropTypes.bool,
    isPending: PropTypes.bool,
    openAddLine: PropTypes.func,
    openCorrectSerial: PropTypes.func,
    openRemoveLine: PropTypes.func,
  }),
};

export default RepairRequestDetailTabs;
